import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.195 32.938a7.168 7.168 0 0 1-7.157-6.78 26.14 26.14 0 0 1 0-2.822 7.168 7.168 0 0 1 7.157-6.781h3.563l1.579-1.777a62.007 62.007 0 0 1 7.574-7.2l1.127-.903a3.072 3.072 0 0 1 4.98 2.115c.403 4.38.604 9.699.604 15.957 0 6.256-.2 11.572-.603 15.951a3.072 3.072 0 0 1-4.983 2.114l-1.18-.948a62.576 62.576 0 0 1-7.669-7.31l-1.43-1.616h-3.562Zm3.044-14.335h-3.044a5.12 5.12 0 0 0-5.112 4.843 24.098 24.098 0 0 0 0 2.6 5.12 5.12 0 0 0 5.112 4.844h3.044V18.603Zm2.048-.686v13.66l1.434 1.62a60.527 60.527 0 0 0 7.418 7.07l1.18.948a1.023 1.023 0 0 0 1.66-.704c.397-4.311.596-9.567.596-15.764 0-6.2-.2-11.457-.596-15.769a1.023 1.023 0 0 0-1.66-.705l-1.128.904a59.957 59.957 0 0 0-7.323 6.96l-1.58 1.78Zm24.999 5.81 4.396 4.396c.965.965-.483 2.413-1.448 1.448l-4.396-4.396-4.396 4.396c-.965.965-2.413-.483-1.448-1.448l4.396-4.396-4.396-4.396c-.965-.965.483-2.413 1.448-1.448l4.396 4.396 4.396-4.396c.965-.965 2.413.483 1.448 1.448l-4.396 4.396Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.195 32.938a7.168 7.168 0 0 1-7.157-6.78 26.14 26.14 0 0 1 0-2.822 7.168 7.168 0 0 1 7.157-6.781h3.563l1.579-1.777a62.007 62.007 0 0 1 7.574-7.2l1.127-.903a3.072 3.072 0 0 1 4.98 2.115c.403 4.38.604 9.699.604 15.957 0 6.256-.2 11.572-.603 15.951a3.072 3.072 0 0 1-4.983 2.114l-1.18-.948a62.576 62.576 0 0 1-7.669-7.31l-1.43-1.616h-3.562Zm3.044-14.335h-3.044a5.12 5.12 0 0 0-5.112 4.843 24.098 24.098 0 0 0 0 2.6 5.12 5.12 0 0 0 5.112 4.844h3.044V18.603Zm2.048-.686v13.66l1.434 1.62a60.527 60.527 0 0 0 7.418 7.07l1.18.948a1.023 1.023 0 0 0 1.66-.704c.397-4.311.596-9.567.596-15.764 0-6.2-.2-11.457-.596-15.769a1.023 1.023 0 0 0-1.66-.705l-1.128.904a59.957 59.957 0 0 0-7.323 6.96l-1.58 1.78Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.286 23.727 4.396 4.396c.965.965-.483 2.413-1.448 1.448l-4.396-4.396-4.396 4.396c-.965.965-2.413-.483-1.448-1.448l4.396-4.396-4.396-4.396c-.965-.965.483-2.413 1.448-1.448l4.396 4.396 4.396-4.396c.965-.965 2.413.483 1.448 1.448l-4.396 4.396Z",
    fill: "currentColor"
  }));
};

var SvgSoundOff = styled(SvgComponent).withConfig({
  displayName: "SoundOff__SvgSoundOff",
  componentId: "sc-1t8pqxp-0"
})(["", " ", ""], size, color);
export default SvgSoundOff;